import { Box, Stack, Typography } from '@mui/material'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { getCrossTalks } from 'app/slices/crosstalk'
import LinkButton from 'components/LinkButton'
import React, { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'

export default function Discussion() {
  const dispatch = useAppDispatch()
  const status = useAppSelector((s) => s.CrossTalk.status)
  const data = useAppSelector((s) => s.CrossTalk.list)
  const { hash } = useLocation()
  useEffect(() => {
    if (status === 'init') dispatch(getCrossTalks())
  }, [status, dispatch])
  useEffect(() => {
    setTimeout(() => {
      document.querySelector(hash || 'header')?.scrollIntoView({
        block: 'center',
        behavior: 'smooth',
      })
    }, 200)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hash])

  const published = useMemo(() => data.filter((f) => f.public), [data])
  return (
    <Stack className="container pb-10 gap-4" id="crosstalk">
      <Stack className="items-center justify-center gap-4 mb-8">
        <Typography className="heading-2 min-w-[120px] text-center">
          座談会
        </Typography>
      </Stack>
      {published.length === 0 && (
        <Stack className="h-[300px] relative justify-center items-center">
          <Stack className="absolute inset-0">
            <Box
              component="img"
              src="/static/fellow-discussion.png"
              alt="fellow-discussion"
              className="w-full h-full object-cover brightness-75 rounded-lg"
              sx={{
                objectPosition: 'center 60%',
              }}
            ></Box>
          </Stack>
          <Typography className="text-white relative z-10 text-xl">
            coming soon・・・
          </Typography>
        </Stack>
      )}
      {published.map((crosstalk) => {
        return (
          <Stack
            className="h-[300px] relative justify-center items-center p-2"
            key={crosstalk._id}
          >
            <Box
              component="p"
              className="absolute top-0.5 left-0.5 rounded z-20 p-1 px-2 text-sm italic bg-white/50"
            >
              {crosstalk.date}
            </Box>
            <Stack className="absolute inset-0">
              <Box
                component="img"
                src={crosstalk.thumbnail || '/static/fellow-discussion.png'}
                alt="fellow-discussion"
                className="w-full h-full object-cover rounded-lg bg-blend-multiply bg-black/25"
                sx={{
                  objectPosition: 'center 60%',
                }}
              ></Box>
            </Stack>
            <Stack className="justify-center items-center gap-4 relative z-10 bg-white/70 rounded-xl p-4">
              <Typography className="text-current text-shadow-white relative z-10 text-xl font-semibold">
                {crosstalk.title}
              </Typography>
              <LinkButton
                text="詳しくはこちら"
                arrowIcon
                to={'/crosstalk/' + crosstalk._id}
                sx={{
                  border: 'solid currentColor',
                  borderWidth: '2px 0',
                  bgcolor: '#fffa',
                }}
              />
            </Stack>
          </Stack>
        )
      })}
    </Stack>
  )
}
